import { render, staticRenderFns } from "./SportsPromos.vue?vue&type=template&id=76b8476e&scoped=true"
import script from "./SportsPromos.vue?vue&type=script&lang=js"
export * from "./SportsPromos.vue?vue&type=script&lang=js"
import style0 from "./SportsPromos.vue?vue&type=style&index=0&id=76b8476e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8476e",
  null
  
)

export default component.exports